export const enum ButtonState {
  Default = 'default',
  Hover = 'hover',
}

export interface ISettingsEvents {
  buttonState: ButtonState;
  showMAEmptyList: boolean;
}
